import React, { useContext } from 'react';
import { Box, Tooltip, Typography, Checkbox, FormControlLabel } from '@material-ui/core';
import quickReportStyle from './QuickReport.style';
import { withStyles } from '@material-ui/core/styles';
import {
	TOOLTIP_TEMPLLATE_MSG,
	TOOLTIP_SHOW_MSG,
	CUSTOMIZE,
	RUN,
	DC_TMPT_LIST,
	STR_TMPT_LIST,
	STR_DEMAND_LIST,
	STR_ORDER_LIST,
	ITEM_ACCESS_TYPE,
	GREGORIAN_CALENDAR,
	TENDER_ANALYSIS_LIST,
	GENERAL_CANNED_REPORT_LIST,
	SHOW_AS_CANNED_REPORT,
	SHIP_TO_ZIP_LIST,
	CUSTOM_SHOW_TOOLTIP,
	PERSONA
} from 'constants/constant';
import { colors } from 'theme/color-palette';
import { getFirstTimeUsrStatus } from 'components/UserTour/Tour.action';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
	getRequestBody,
	countDimensionFilter,
	validateDimFilters
} from 'components/Preview/Preview.utils';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import {
	getRowCount,
	setSelectedList,
	setIsMandateCheck,
	clearPreview,
	resetDraft,
	getPinnedAttribute,
	setFilterList,
	setPrevFilterList,
	setRequiredCheck
} from 'components/Preview/Preview.actions';
import { UserPortalContext } from 'context/appcontext';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import { isMultiWeekSel, isCalFamily } from 'components/Preview/filter/FilterCondition';
const { PURPLE } = colors;
import RBButton from '../../Shared/RBButton';
import { FEATURES } from 'helper/basicFeatureFlag';
import { getTmplName } from 'helper/utils';
import ItemShare from 'components/Shared/ItemShare';
import { deepClone } from 'helper/helper';
import { getDfltFilter } from 'helper/utils';

const StyledFormControlLabel = withStyles(() => ({
	label: {
		fontSize: '14px',
		fontFamily: 'Bogle-Regular'
	}
}))(FormControlLabel);

function FooterButton(props) {
	const {
		isTooltipCheck,
		setIsTooltipCheck,
		show,
		showTooltip = false,
		selectedTemplateData,
		subTemplateName
	} = props;
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const classes = quickReportStyle();
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, customerType } = portalUserContext;
	const { companyName, userPersona } = userDetails?.result;
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const defaultDlyFilter = useSelector((state) => state.templateReducer.defaultDlyFilter);
	const defaultWklyFilter = useSelector((state) => state.templateReducer.defaultWklyFilter);
	const defaultMultiWklyFilter = useSelector(
		(state) => state.templateReducer.defaultMultiWklyFilter
	);
	const selectedList = useSelector((state) => state.previewReducer.selectedList);
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const subTemplateLoading = useSelector((state) => state.templateReducer.subTemplateLoading);
	const { DISABLE_CUSTOMIZE: disableCustomizeByFeature } = FEATURES[customerType].TEMPLATE_PAGE;
	const disableCustomize =
		disableCustomizeByFeature && !GENERAL_CANNED_REPORT_LIST.includes(Number(selectedTemplate));
	const { itemShareStatus } = useSelector((state) => state.previewReducer);
	const showRun = selectedList.length > 0;
	const COMPANYNAME = 'COMPANYNAME';

	const getParentCompName = (isGregorian) => {
		const WK_SPEC_TMPT = [...STR_TMPT_LIST, ...DC_TMPT_LIST, ...STR_DEMAND_LIST, ...STR_ORDER_LIST];
		const obj = {};
		let key = defaultDlyFilter;
		if (key === undefined) {
			return obj;
		}
		const value = userPersona === PERSONA.CATMAN ? PERSONA.CATMAN : COMPANYNAME;
		const isMultiWeek = filterList?.some((el) => isMultiWeekSel(el, Number(selectedTemplate)));
		let isWeekSel = filterList?.some((el) => el.businessName === 'Week');
		if (isGregorian) {
			isWeekSel = false;
		}
		if (isMultiWeek) {
			key = defaultMultiWklyFilter;
		} else if (WK_SPEC_TMPT.includes(Number(selectedTemplate)) && isWeekSel) {
			key = defaultWklyFilter;
		}
		if (userPersona !== PERSONA.MERCHANT) {
			obj[key] = value;
		}
		return obj;
	};

	const addRequiredFilter = () => {
		if ([...TENDER_ANALYSIS_LIST, ...SHIP_TO_ZIP_LIST].includes(Number(selectedTemplate))) {
			//check if default filter is already included
			if (filterList.some((_o) => isCalFamily(_o))) {
				return;
			}
			const dfltFilter = getDfltFilter([selectedTemplateData], undefined, true);
			let newFilterList = [...filterList, ...dfltFilter];
			dispatch(setFilterList(newFilterList));
			dispatch(setPrevFilterList(newFilterList));
		}
	};

	const handleCustomize = () => {
		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.CUSTOMIZE_QUICK_REPORT} ${subTemplateName}`,
			location: PAGE_ID.QUICK_REPORT
		});
		dispatch(
			getPinnedAttribute({
				companyName,
				templateId: selectedTemplate
			})
		);
		dispatch(clearPreview([]));
		dispatch(resetDraft());
		addRequiredFilter();
		navigate('/preview');
	};

	const handleRun = () => {
		const isGregorian = filterList?.some((filter) => filter?.parent === GREGORIAN_CALENDAR);
		const parentName = getParentCompName(isGregorian);
		const allData = [...templateData, ...cannedReportData];
		const selectedTmplData = allData.filter(
			(item) => item.templateName === getTmplName(selectedTemplate)
		);

		// Analytics
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.BUILD_QUICK_REPORT} ${subTemplateName}`,
			location: PAGE_ID.QUICK_REPORT
		});
		if (
			userPersona === PERSONA.MERCHANT ||
			SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate))
		) {
			const dimensionFilters = countDimensionFilter(filterList);
			if (dimensionFilters.length === 0) {
				dispatch(setIsMandateCheck(true));
				return;
			}
			dispatch(setIsMandateCheck(false));
		}

		if (!validateDimFilters(selectedList, filterList, Number(selectedTemplate))) {
			addRequiredFilter();
			dispatch(setIsMandateCheck(true));
			return;
		}

		if ([...TENDER_ANALYSIS_LIST, ...SHIP_TO_ZIP_LIST].includes(Number(selectedTemplate))) {
			if (
				!filterList.some((_o) => {
					return isCalFamily(_o) && _o.filter.condition !== '';
				})
			) {
				dispatch(setRequiredCheck(null));
				return;
			}
		}
		// /***
		//  *  From Backend, Item Access Type does comes in all quick report runquery object.
		//  * Hence, explicitly need to remove if item share is OFF.
		//  */
		let list = deepClone(selectedList);
		if (!itemShareStatus.curr) {
			list = list.filter((el) => el.businessName !== ITEM_ACCESS_TYPE);
		}

		dispatch(getFirstTimeUsrStatus({ companyName }));
		dispatch(
			getRowCount({
				requestBody: getRequestBody({
					isPreview: false,
					filterList,
					selectedTemplate,
					selectedList: list,
					selectedView,
					parentName,
					dispatchSelectedList,
					persona: userPersona,
					selectedTmplData,
					userDetails,
					customerType,
					itemShare: itemShareStatus.curr
				}),
				companyName,
				templateId: selectedTemplate
			})
		);
		dispatch(resetDraft());
		navigate({
			pathname: '/reports',
			search: '?quick=true'
		});
	};

	const dispatchSelectedList = (param) => {
		dispatch(setSelectedList(param));
	};

	const getTooltipText = () => {
		return (
			<Box className={classes.tooltipPanel}>
				<Typography className={classes.tooltipText}>{TOOLTIP_TEMPLLATE_MSG}</Typography>
				<Typography className={classes.tooltipShowMsg}>
					<StyledFormControlLabel
						control={
							<Checkbox
								sx={{
									color: PURPLE,
									'&.Mui-checked': {
										color: PURPLE
									}
								}}
								color="primary"
								checked={isTooltipCheck}
								onChange={() => {
									setIsTooltipCheck(!isTooltipCheck);
								}}
								name="Show"
							/>
						}
						label={TOOLTIP_SHOW_MSG}
					/>
				</Typography>
			</Box>
		);
	};
	const customizeLabel = () => {
		return (
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<span>{CUSTOMIZE}</span>
				<span>
					<LockOutlinedIcon className={classes.lockIcon}></LockOutlinedIcon>
				</span>
			</div>
		);
	};

	return (
		<Box className={classes.buttonContainer} style={{ padding: '8px 16px' }}>
			<Box style={{ marginBottom: 8 }}>
				<ItemShare tooltipPosition="top" />
			</Box>
			{showRun && (
				<Tooltip
					title={getTooltipText()}
					open={
						show &&
						showTooltip &&
						[null, 'false'].includes(localStorage.getItem(CUSTOM_SHOW_TOOLTIP))
					}
					placement="left"
					classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
					aria-label="template-msg"
					arrow>
					<span>
						<RBButton
							cbHandleClick={handleRun}
							disabled={selectedTemplateData === null || subTemplateLoading}
							btnName={RUN}
							type="primary"
							id="submit"
						/>
					</span>
				</Tooltip>
			)}
			<RBButton
				id="cancel"
				cbHandleClick={handleCustomize}
				disabled={subTemplateLoading || disableCustomize}
				btnName={disableCustomize ? customizeLabel() : CUSTOMIZE}
				type="secondary"
			/>
		</Box>
	);
}

export default FooterButton;
